import { Copy } from '../copy/Copy';

export const NAV_LIST_ITEMS = [
  {
    name: Copy.generate('NavList.listItem.1'),
    to: '/about',
  },
  {
    name: Copy.generate('NavList.listItem.2'),
    to: '/academy',
  },
  {
    name: Copy.generate('NavList.listItem.3'),
    to: '/competition',
  },
  {
    name: Copy.generate('NavList.listItem.5'),
    to: '/discography',
  },
  {
    name: Copy.generate('NavList.listItem.4'),
    to: '/gallery',
  },
  {
    name: Copy.generate('Global.contactUs'),
    to: '/contact',
  },
];
